import { DetailViewCard } from '../../Compounds/CardWithTitle/DetailViewCard';
import { DetailPanelContainer } from '../../Compounds/DetailPanel/DetailPanelContainer';
import { LabelValueField, EditFieldType } from '../../Compounds/DetailPanel/LabelValueField';
import { getFormattedDate } from '../../../utils/helpers';
import { hasDataOrHigherPermissions } from '../../../store/User';
import { DetailPanelParams } from '../../Compounds/DetailPanel/DetailPanel';
import { PaymentRecipientType } from '../../../store/PaymentRecipient';
import { updatePaymentRecipient, PaymentRecipient } from '../../../store/PaymentRecipient';

export interface RecipientDetailsParams {
  data: PaymentRecipient;
}

export const infoSections = (data: PaymentRecipient): DetailPanelParams[] => [
  {
    data,
    canEdit: hasDataOrHigherPermissions()
      ? [
          {
            field: 'name',
            type: EditFieldType.TEXT
          },
          {
            field: 'type',
            type: EditFieldType.SELECT,
            options: Object.values(PaymentRecipientType)
          }
        ]
      : [],
    fieldMap: {
      name: 'Name',
      type: 'Type'
    },
    order: ['name', 'type']
  }
];

export const RecipientDetails = ({ data }: RecipientDetailsParams) => {
  const saveAction = (update: PaymentRecipient) => updatePaymentRecipient(update, true);

  return (
    <div
      className="space-y-4"
      data-testid="payment-recipient-details-drawer">
      <DetailViewCard
        enableCollapse
        key="info-detail-card"
        title="Info">
        <div
          data-testid="info-detail-card"
          className="min-h-[5rem]">
          <DetailPanelContainer
            data={infoSections(data)}
            saveAction={(d) => saveAction(d as PaymentRecipient)}
          />
        </div>
      </DetailViewCard>
      <DetailViewCard
        enableCollapse
        key="meta-detail-card"
        title="Meta">
        <div
          className="flex px-4 pt-4 w-full"
          data-testid="meta-detail-card">
          <LabelValueField
            label="Created At"
            value={getFormattedDate(data.createdAt, 'lll')}
            field="createdAt"
          />
          <LabelValueField
            label="Modified At"
            value={getFormattedDate(data.updatedAt, 'lll')}
            field="updatedAt"
          />
        </div>
        <div className="flex px-4 w-full">
          <LabelValueField
            label="Created By"
            value={`${data.createdBy?.firstName || ''} ${data.createdBy?.lastName || ''}`}
            field="createdBy.name"
          />
          <LabelValueField
            label="Modified By"
            value={`${data.modifiedBy?.firstName || ''} ${data.modifiedBy?.lastName || ''}`}
            field="modifiedBy.name"
          />
        </div>
        <div className="flex px-4 w-full">
          <LabelValueField
            label="ID"
            value={data.id || ''}
            field="id"
          />
        </div>
      </DetailViewCard>
    </div>
  );
};
